export class EvaMessage{
    title:string;
    text:string;
    type:string;
    icon:string;

    constructor(title:string,
                text:string,
                type:string,
                icon:string){
        this.title = title;
        this.text = text;
        this.type = type;
        this.icon = icon
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/shared/eva-message/eva-message.ts